import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { CustomDropdown } from '../../../common/custom-form/custom-dropdown.component';
import { TRANSLATIONS } from '../../../../utils/constant.utils';
import { TabberButton } from '../../../common/custom-form/tabber-button.component';
import { CustomMultiSelect } from '../../../common/custom-form/custom-multi-select.component';
import { SelectFieldFloatingLabel as Select } from '../../../common/custom-form/select-filter.component';
import { Button } from "react-bootstrap";
import UploadButton from '../../../common/upload-button/upload-button';
import Translation from '../../../common/translation/translation.component';
import TableWithButton from '../../../common/details-table/table-with-button.component';
// remove this once API implemented
const SAMPLE_VENDOR_OPTIONS = [
    { Key: '1', Value: 'AT&T' },
    { Key: '2', Value: 'Verizon' },
    { Key: '3', Value: 'T-Mobile' },
    { Key: '4', Value: 'Comcast' },
    { Key: '5', Value: 'Lumen' },
];

// remove this once API implemented
const SAMPLE_STATUS_OPTIONS = [
    { Key: '1', Value: 'Active' },
    { Key: '2', Value: 'Inactive' },
    { Key: '3', Value: 'Pending' },
    { Key: '4', Value: 'Disconnected' },
];

// remove this once API implemented
const SAMPLE_TABLE_HEADER = [
    {
        Filename: { propName: 'Filename', name: 'Filename', order: 0, hidden: false },
        UploadDate: { propName: 'UploadDate', name: 'Upload Date', order: 1, hidden: false },
        Status: { propName: 'Status', name: 'Status', order: 2, hidden: false },
        LastModified: { propName: 'LastModified', name: 'Last Modified', order: 3, hidden: false },
    },
];

const KbArticle_FILE_FORMATS = ['CSV', 'XLS', 'XLSX', 'DOC', 'DOCX', 'PDF', 'TXT'];
const KbArticle_MAX_FILE_SIZE_MB = 10;

// options for the inline row-edit Status dropdown
const ROW_STATUS_OPTIONS = [
    { Key: 'Active', Value: 'Active' },
    { Key: 'Inactive', Value: 'Inactive' },
];

// remove this once API implemented
const SAMPLE_TABLE_DATA = [
    {
        Key: 1,
        Filename: 'TEM Invoice Processing Runbook Ver 1.2',
        UploadDate: '07/27/2026 2:15 PM',
        Status: 'Active',
        LastModified: 'Natalie Foster on 07/27/2026 2:15 PM',
    },
    {
        Key: 2,
        Filename: 'TEM Invoice Processing Runbook Ver 1.3',
        UploadDate: '07/27/2026 2:20 PM',
        Status: 'Active',
        LastModified: 'Natalie Foster on 07/27/2026 2:20 PM',
    },
    {
        Key: 3,
        Filename: 'Vendor Onboarding Checklist',
        UploadDate: '07/26/2026 9:05 AM',
        Status: 'Inactive',
        LastModified: 'James Carter on 07/26/2026 9:05 AM',
    },
    {
        Key: 4,
        Filename: 'Monthly Billing Summary June',
        UploadDate: '07/25/2026 4:40 PM',
        Status: 'Active',
        LastModified: 'James Carter on 07/25/2026 4:40 PM',
    },
    {
        Key: 5,
        Filename: 'Credit Note Template',
        UploadDate: '07/24/2026 11:10 AM',
        Status: 'Pending',
        LastModified: 'Natalie Foster on 07/24/2026 11:10 AM',
    },
    {
        Key: 6,
        Filename: 'Vendor Contract Renewal Notice',
        UploadDate: '07/23/2026 3:30 PM',
        Status: 'Active',
        LastModified: 'Olivia Bennett on 07/23/2026 3:30 PM',
    },
    {
        Key: 7,
        Filename: 'Invoice Discrepancy Report',
        UploadDate: '07/22/2026 1:15 PM',
        Status: 'Inactive',
        LastModified: 'Olivia Bennett on 07/22/2026 1:15 PM',
    },
    {
        Key: 8,
        Filename: 'TEM Invoice Processing Runbook Ver 1.4',
        UploadDate: '07/21/2026 10:50 AM',
        Status: 'Active',
        LastModified: 'James Carter on 07/21/2026 10:50 AM',
    },
    {
        Key: 9,
        Filename: 'Quarterly Spend Analysis',
        UploadDate: '07/20/2026 8:25 AM',
        Status: 'Active',
        LastModified: 'Natalie Foster on 07/20/2026 8:25 AM',
    },
    {
        Key: 10,
        Filename: 'Vendor Rate Card Update',
        UploadDate: '07/19/2026 2:05 PM',
        Status: 'Pending',
        LastModified: 'Olivia Bennett on 07/19/2026 2:05 PM',
    },
    {
        Key: 11,
        Filename: 'Billing Agent Configuration Notes',
        UploadDate: '07/18/2026 9:45 AM',
        Status: 'Active',
        LastModified: 'James Carter on 07/18/2026 9:45 AM',
    },
    {
        Key: 12,
        Filename: 'Invoice Extraction Error Log',
        UploadDate: '07/17/2026 5:15 PM',
        Status: 'Inactive',
        LastModified: 'Natalie Foster on 07/17/2026 5:15 PM',
    },
    {
        Key: 13,
        Filename: 'TEM Invoice Processing Runbook Ver 1.5',
        UploadDate: '07/16/2026 12:00 PM',
        Status: 'Active',
        LastModified: 'Olivia Bennett on 07/16/2026 12:00 PM',
    },
    {
        Key: 14,
        Filename: 'Vendor Compliance Checklist',
        UploadDate: '07/15/2026 3:55 PM',
        Status: 'Pending',
        LastModified: 'James Carter on 07/15/2026 3:55 PM',
    },
    {
        Key: 15,
        Filename: 'Credit Note Reconciliation Report',
        UploadDate: '07/14/2026 10:30 AM',
        Status: 'Active',
        LastModified: 'Natalie Foster on 07/14/2026 10:30 AM',
    },
];

const KyberBillAgentForm = ({ kyberAgentEnabled }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [enableAgent, setEnableAgent] = useState(false);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [selectedDisputes, setSelectedDisputes] = useState('');
    const [kbArticle, setKbArticle] = useState('');
    const [dataTable, setDataTable] = useState([
        { HeaderItem: SAMPLE_TABLE_HEADER, dataItem: SAMPLE_TABLE_DATA },
    ]);
    const [enableEdit, setEnableEdit] = useState(false);
    const [keyIndex, setKeyIndex] = useState(null);
    const [editedRowValues, setEditedRowValues] = useState({});
    const tabberButtonRef = useRef(null);
    const uploadButtonRef = useRef(null);
    const { locale } = useSelector(state => state.translation);

    useEffect(() => {
        if (!kyberAgentEnabled) {
            setEnableAgent(false);
        }
    }, [kyberAgentEnabled]);

    const translator = (key, isCapitalize = true) => {
        if (locale === null || locale === '')
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return isCapitalize ? TRANSLATIONS[locale][key]?.toUpperCase() : TRANSLATIONS[locale][key];
    }

    const handleToggle = () => {
        setIsCollapsed(prev => !prev);
    }

    const handleSelectedRoles = (roles) => {
        setSelectedRoles(roles);
    }

    const handleSelectedDisputes = (fieldProp, value) => {
        setSelectedDisputes(value);
    }

    const handleCancel = () => {
        setSelectedRoles([]);
        setSelectedDisputes('');
        setKbArticle('');
        uploadButtonRef.current?.setUploadFileName('');
    }

    const handleClickAddBtn = () => {
    }

    const disabledBtn = !(selectedRoles.length && selectedDisputes);

    const handleKbArticle = (fileName) => {
        setKbArticle(fileName);
    }

    const handleClickExtract = () => {
    }

    const handleDeleteRow = (index) => {
        setDataTable(prev => {
            const updated = [...prev];
            updated[0] = { ...updated[0], dataItem: updated[0].dataItem.filter((_, i) => i !== index) };
            return updated;
        });
    }

    const handleUpdateRow = (index) => {
        setDataTable(prev => {
            const updated = [...prev];
            const dataItem = [...updated[0].dataItem];
            dataItem[index] = { ...dataItem[index], ...editedRowValues };
            updated[0] = { ...updated[0], dataItem };
            return updated;
        });
        setEditedRowValues({});
        setEnableEdit(false);
        setKeyIndex(null);
    }

    const handleEnableEdit = (enable, index) => {
        setEnableEdit(enable);
        setKeyIndex(index);
        if (!enable) {
            setEditedRowValues({});
        }
    }

    const handleRowFieldChange = (propName, e) => {
        const value = e.target.value;
        setEditedRowValues(prev => ({ ...prev, [propName]: value }));
    }

    // remove this once API implemented
    const handleFileDownload = (item) => {
    }

    const handleFormCancel = () => {
        setSelectedRoles([]);
        setSelectedDisputes('');
        setKbArticle('');
        setIsCollapsed(false);
    }

    const handleClickSaveBtn = () => {
    }

    return (
        <div className="kyberconfig-form-container">
          <CustomDropdown activeDropdown={isCollapsed} toggleActiveState={handleToggle} label={translator("kyber_bill_agent", false)} toggleStatus={enableAgent} >
            <div className="kyberconfig-form-content">
                <div className="kyberconfig-toggle-row">
                    <TabberButton ref={tabberButtonRef} title="ENABLE AGENT"
                        value={enableAgent}
                        onToggle={(isActive) => setEnableAgent(isActive)}
                    />
                    <CustomMultiSelect
                        options={SAMPLE_VENDOR_OPTIONS}
                        label={translator('roles_enabled', false)}
                        placeholder={translator('select_placeholder', false)}
                        requiredField={true}
                        isDisabled={!enableAgent}
                        fieldProps="kyberConfigFormA.ListIds"
                        onChange={handleSelectedRoles}
                        selectedOptions={selectedRoles}
                    />
                    <Select
                        className="form-select required"
                        label={translator('automate_dispute_using_kb')}
                        value={selectedDisputes}
                        options={SAMPLE_STATUS_OPTIONS}
                        placeholder={translator('select_placeholder', false)}
                        fieldProp='kyberConfigFormA.disputesID'
                        onChangeAction={handleSelectedDisputes}
                        disabled={!enableAgent}
                    />
                </div>
                <UploadButton
                        ref={uploadButtonRef}
                        onChange={handleKbArticle}
                        onClickExtract={handleClickExtract}
                        title={"UPLOAD KB ARTICLE"}
                        isReadAndWrite={true}
                        isReadOnly={false}
                        isDisabled={!enableAgent}
                        fileFormat={KbArticle_FILE_FORMATS}
                        fileSizeMB={KbArticle_MAX_FILE_SIZE_MB}
                        errorModalTitle="Error"
                />
                <div className="add-button-container custom-add-button">
                    <div className="btn-tooltiptext">
                        <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" disabled={!enableAgent} onClick={handleCancel}>Cancel</Button>
                        {/* <span className="tooltip-text">{<Translation translationKey="" />}</span> */}
                    </div>

                    <div className={'btn-tooltiptext'}>
                        <Button
                            disabled={!enableAgent || disabledBtn}
                            onClick={handleClickAddBtn}
                            variant="primary"
                            className="btn-add"
                        >
                            Add
                        </Button>
                        {/* <span className="tooltip-text"><Translation translationKey="" /></span> */}
                    </div>
                </div>
                <TableWithButton
                        datatable={dataTable}
                        enablePagination={true}
                        haveDeleteBtn={true}
                        haveEditBtn={true}
                        deleteAction={handleDeleteRow}
                        updateAction={handleUpdateRow}
                        searchableDropdownData={[]}
                        inputField={[]}
                        dropdownField={['Status']}
                        dropdownOptionsMap={{ Status: ROW_STATUS_OPTIONS }}
                        optionsMap={[]}
                        downloadableColumn="Filename"
                        onFileDownload={handleFileDownload}
                        selectedItems={editedRowValues}
                        handleSelectChange={() => { }}
                        handleInputChange={handleRowFieldChange}
                        handleOpenNotif={() => { }}
                        handleGetFieldData={() => { }}
                        handelEnableEdit={handleEnableEdit}
                        handleCloseNotif={() => { }}
                        enableEdit={enableEdit}
                        keyIndex={keyIndex}
                        hasError={{}}
                        planComponentError={false}
                        setDefaultError={() => { }}
                />
                <div className="add-button-container custom-add-button justify-content-end">
                    <div className="btn-tooltiptext">
                        <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" disabled={!enableAgent} onClick={handleFormCancel}>Cancel</Button>
                        {/* <span className="tooltip-text">{<Translation translationKey="" />}</span> */}
                    </div>

                    <div className={'btn-tooltiptext'}>
                        <Button
                            disabled={!enableAgent || disabledBtn}
                            onClick={handleClickSaveBtn}
                            variant="primary"
                            className="btn-add"
                        >
                            Save
                        </Button>
                        {/* <span className="tooltip-text"><Translation translationKey="" /></span> */}
                    </div>
                </div>
            </div>

          </CustomDropdown>
        </div>
    );
};


export default KyberBillAgentForm;